import { usePecField } from 'components/form'
import { PrivateRoute } from 'components/route'
import { MChatPerguntaEnum, MChatRiscoEnum } from 'graphql/types.generated'
import { noop } from 'lodash'
import React, { Fragment, useRef } from 'react'
import { useRouteMatch } from 'react-router'
import { NIVEL_SUPERIOR } from 'types/NivelCbo'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoModal } from '../consulta-seguimento-modal/ConsultaSeguimentoModal'
import { CONSULTA_SEGUIMENTO_URL_MODAL, ConsultaSeguimentoFieldModel } from '../model-consultaSeguimento'
import { calculateResultadoConsultaSeguimento } from '../utils-consultaSeguimento'
import { ConsultaSeguimentoFieldAccordionSection } from './ConsultaSeguimentoFieldAccordionSection'

interface ConsultaSeguimentoFieldProps {
  name: MetaPath<ConsultaSeguimentoFieldModel>
  perguntasFalhasNoMChat: MChatPerguntaEnum[]
  valuesAtendimentoAnterior: ConsultaSeguimentoFieldModel
  mChatAtualRisco: MChatRiscoEnum
  mChatAnteriorRisco: MChatRiscoEnum
}

export function ConsultaSeguimentoField(props: Readonly<ConsultaSeguimentoFieldProps>) {
  const { name, perguntasFalhasNoMChat, valuesAtendimentoAnterior, mChatAtualRisco, mChatAnteriorRisco } = props

  const match = useRouteMatch()
  const modalConsultaSeguimentoUrl = `${match.url}${CONSULTA_SEGUIMENTO_URL_MODAL}`
  const aplicarButtonRef = useRef<HTMLButtonElement>(null)

  const {
    input: { value, onChange },
  } = usePecField({ name })

  const handleSave = (values: ConsultaSeguimentoFieldModel) => {
    const resultado = calculateResultadoConsultaSeguimento(values.aplicacao)
    onChange({ ...values, resultado })
  }

  return (
    <Fragment>
      <ConsultaSeguimentoFieldAccordionSection
        name={name}
        valuesAtendimentoAnterior={valuesAtendimentoAnterior}
        modalUrl={modalConsultaSeguimentoUrl}
        mChatAtualRisco={mChatAtualRisco}
        mChatAnteriorRisco={mChatAnteriorRisco}
        aplicarButtonRef={aplicarButtonRef}
        onDelete={noop}
      />

      <PrivateRoute cbos={NIVEL_SUPERIOR} path={modalConsultaSeguimentoUrl} exact>
        <ConsultaSeguimentoModal
          currentValue={value}
          perguntasFalhasNoMChat={perguntasFalhasNoMChat}
          aplicarButtonRef={aplicarButtonRef}
          onSave={handleSave}
        />
      </PrivateRoute>
    </Fragment>
  )
}
